import { request } from './client';

export const emailSettingsService = {
  // GET: Fetch all emails
  getEmailSettings: () => request('/email-settings'),
  
  addEmail: (email) => request('/email-settings', { 
    method: 'POST', 
    body: { email } 
  }),
  
  deleteEmail: (id) => request(`/email-settings/${id}`, { 
    method: 'DELETE' 
  }),

  // --- Single Alert Template ---

  getTemplate: () => request('/email-settings/template'),
  
  saveTemplate: (template) => request('/email-settings/template', { 
    method: 'POST', 
    body: { template } 
  }),

  // Send Test Email (Single Alert)
  sendTestEmail: (htmlTemplate = null) => request('/email-settings/test', {
    method: 'POST',
    body: { htmlTemplate } // Send the template if provided
  }),

  // --- Weekly Report Template ---

  getWeeklyTemplate: () => request('/email-settings/weekly-template'),
  
  saveWeeklyTemplate: (template) => request('/email-settings/weekly-template', { 
    method: 'POST', 
    body: { template } 
  }),

  // Send Test Email (Weekly Report)
  sendWeeklyTestEmail: (htmlTemplate = null) => request('/email-settings/weekly-test', {
    method: 'POST',
    body: { htmlTemplate } // Send the template if provided
  }),
};
